// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.active-filter {
  border-color: #e88d4f !important;
  border: 2px solid;
}

.multiple-row-add {
  position: relative;
}
.multiple-row-add .minus-circle {
  position: absolute;
  top: 46%;
  right: -40px;
  color: var(--bs-red);
}

.filter-account {
  width: 20vw;
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/entities/activities/view/style.scss"],"names":[],"mappings":"AAAA;EACE,gCAAA;EACA,iBAAA;AACF;;AACA;EACE,kBAAA;AAEF;AADE;EACE,kBAAA;EACA,QAAA;EACA,YAAA;EACA,oBAAA;AAGJ;;AACA;EACE,WAAA;AAEF","sourcesContent":[".active-filter {\r\n  border-color: #e88d4f !important;\r\n  border: 2px solid;\r\n}\r\n.multiple-row-add {\r\n  position: relative;\r\n  .minus-circle {\r\n    position: absolute;\r\n    top: 46%;\r\n    right: -40px;\r\n    color: var(--bs-red);\r\n  }\r\n}\r\n\r\n.filter-account {\r\n  width: 20vw;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
